module.exports = __webpack_public_path__ + "static/media/upload_more.b397fe58.svg";